import { getLocation } from '@change-corgi/core/window';

type Navigate = (to: string) => void;

export function navigateToProfile(slug: string, navigate: Navigate) {
	const redirectTo = encodeURIComponent(`/p/${slug}/dashboard/home`);
	navigate(`/account_settings/profile?redirectTo=${redirectTo}`);
}

export function navigateToGroupRecommendations(slug: string, navigate: Navigate) {
	navigate(`/p/${slug}/dashboard/share#recommendations-section`);
}

export function navigateToReadyToSharePosts(
	slug: string,
	navigate: Navigate,
	platform?: 'facebook' | 'instagram' | 'reddit' | 'facebookgroups',
) {
	const location = getLocation();
	const searchParams = new URLSearchParams(location.search);
	if (platform) {
		searchParams.set('platform', platform);
	}
	const queryString = searchParams.toString();
	const url = `/p/${slug}/dashboard/share${queryString ? `?${queryString}` : ''}#ready-to-share-posts`;
	navigate(url);
}

export function navigateToPostUpdate(slug: string, navigate: Navigate) {
	navigate(`/p/${encodeURIComponent(slug)}/dashboard/updates`);
}
